export default {
	welcome: "Bienvenido a ORI",
	subtitle: "Sistema de Gestión para Templos de Umbanda",
	description: "Una plataforma completa para gestionar la vida espiritual de tu templo, desde el seguimiento del camino mediúmnico hasta la organización de rituales.",
	trust: {
		secure: "Seguro y Confiable",
		secureDesc: "Datos protegidos con encriptación",
		respectful: "Respetuoso",
		respectfulDesc: "Desarrollado con cariño y respeto a las tradiciones",
		intuitive: "Intuitivo",
		intuitiveDesc: "Interfaz simple y fácil de usar",
	},
	tagline: "Construido de un hijo del Axé para otro hijo del Axé",
	howItWorks: {
		title: "Cómo Funciona",
		subtitle: "En tres simples pasos, tu templo estará organizado",
		step1: {
			title: "Registra tu Templo",
			description: "Crea tu cuenta, define el nombre del templo e invita a los usuarios",
		},
		step2: {
			title: "Configura tu Casa",
			description: "Agrega los médiums, sus guías, sus tipos de atención y rituales",
		},
		step3: {
			title: "Gestiona con Facilidad",
			description: "Controla rituales, atendimientos, finanzas y acompaña el camino mediúmnico",
		},
	},
	faq: {
		title: "Preguntas Frecuentes",
		q1: "¿ORI tiene planes pagos?",
		a1: "¡Sí! Ofrecemos 30 días gratis para probar. Después del período de prueba, elige el plan ideal para tu templo.",
		q2: "¿Mis datos están seguros?",
		a2: "Absolutamente. Usamos encriptación, aislamiento por templo (RLS) y respaldos automáticos. Ningún templo accede a datos de otro.",
		q3: "¿Funciona en celular y tablet?",
		a3: "Estamos trabajando en la compatibilidad con celular. En tablets, el sistema funciona perfectamente.",
		q4: "¿Puedo llamar fichas en una TV?",
		a4: "Sí, ORI tiene una app Android para Google TV o Fire TV donde puedes llamar fichas desde tablet o celular, además de mostrar mensajes y videos personalizados para los consultantes.",
		q5: "¿Puedo usar mis fichas físicas? ¿O imprime fichas?",
		a5: "Puedes usar tus fichas físicas, o usar la opción de imprimir mediante impresora térmica. El costo por ticket impreso es inferior a 1 centavo. Además, el ticket tiene más información y puede incluir mensajes personalizados para cada consultante.",
		q6: "¿Puedo usarlo en más de un templo?",
		a6: "Sí. Una misma cuenta puede estar vinculada a múltiples templos con diferentes roles. Cada templo tiene su propio plan y suscripción independiente.",
		q7: "¿ORI se integra con un banco para recibir pagos?",
		a7: "¡Sí! A través de Mercado Pago, conectas la cuenta de tu templo y cobras mensualidades y contribuciones por PIX o tarjeta de crédito — con enlace de pago, conciliación automática y débito automático recurrente. Las tarifas son del propio Mercado Pago: PIX 0,99% por transacción (liberación al instante) y tarjeta de crédito alrededor del 4,98% (bajando a ~3,98% después de 30 días), incluso en los cobros recurrentes. ORI no cobra nada extra — el dinero cae directo en la cuenta del templo.",
	},
	manual: {
		link: "Manual",
	},
	nav: {
		screens: "Pantallas",
		faq: "FAQ",
		contact: "Contacto",
		plans: "Planes",
	},
	contact: {
		title: "Contáctenos",
		subtitle: "¿Tiene alguna pregunta o sugerencia? ¡Envíenos un mensaje!",
		name: "Nombre",
		subject: "Asunto",
		message: "Mensaje",
		email: "Email",
		phone: "Celular",
		referralSource: "¿Cómo se enteró de ORI?",
		send: "Enviar Mensaje",
		success: "¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.",
		errors: {
			message: "El mensaje es obligatorio",
			email: "El email es obligatorio",
			generic: "Error al enviar el mensaje. Intente de nuevo.",
		},
		referrals: {
			google: "Google / Búsqueda en internet",
			socialMedia: "Redes sociales",
			friend: "Recomendación de un amigo",
			event: "Evento / Congreso",
			other: "Otro",
		},
	},
	cta: {
		login: "Iniciar Sesión",
		dashboard: "Ir al Dashboard",
		getStarted: "Comenzar Ahora",
		learnMore: "Saber Más",
	},
	pricing: {
		noCardRequired: "No se requiere tarjeta durante el período de prueba",
	},
	testimonials: {
		title: "Confianza y Organización Espiritual",
		subtitle: "Desarrollado con respeto y comprensión de las tradiciones umbandistas",
	},
};
